// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAcceptingPurchase_container__BgJON","errorMessage":"NotAcceptingPurchase_errorMessage__zi087","buttonSection":"NotAcceptingPurchase_buttonSection___8g_C"};